<template>
  <app-collapse-item>
    <template slot="header" slot-scope="props">
      <!-- SLOT DE TITULO, PERSONALIZAR BARRA GENERAL-->
      <feather-icon
        :icon="!!props.visible?'ChevronUpIcon':'ChevronDownIcon'"
        size="18"
        class="mr-1 icon-header"
      />
      <span class="lead collapse-title">{{ param.name }} ({{ levelDescription }})</span>
    </template>
    <template slot="header-acction">
      <span
        v-for="(levelItem, index) in levelsVisibles"
        :key="'level-'+index"
        class="level-config"
        @click="changeLevelView(levelItem.id)" v-b-tooltip.hover :title="levelItem.title"
      >
         <b-avatar
           size="25"
           :icon="levelItem.icon"
           :variant="level === levelItem.id ?
            'success' :
            config[`valor${capitalize(levelItem.id)}`] ?
            'info' :
            'secondary'"
         />
      </span>
    </template>
    <div class="row">
      <div class="col-md-12">
        Descripción: {{ param.description }}
      </div>
      <div class="col-md-6">
        Parametro Id:
        <span
          v-b-tooltip.hover
          :title="wasCopied?'Parametro Id copiado al portapapeldes':'Copiar Parametro Id'"
          :class="{ 'text-success': wasCopied }"
          class="cursor-pointer"
          @click="copyToClipboard(param.parameter_id)"
        >
          {{ param.parameter_id }}
        </span>
      </div>
      <div class="col-md-6">
        Ultima Actualizacion: {{ configurationDate }}
      </div>
    </div>
    <br>
    <config-input-wrapper
      :selected-user-id="selectedUserId"
      :application="application"
      :key="level"
      :type="param.type"
      :config="param.config"
      :level="level"
      :levels="levels"
      :param="param.parameter_id"
      :parameter="param"
      :value="value"
      v-show="init"
      @saved="onSaveValue"
    />
  </app-collapse-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import ConfigInputWrapper
from '@/febos/global/empresas/componentes/configs/inputs/ConfigInputWrapper';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem';
import { levels } from '@/febos/global/utils/configurations';

const capitalize = (str) => str.replace(/^\w/, (c) => c.toUpperCase());

export default {
  name: 'ConfigListItem',
  mixins: [CopyToClipboard],
  components: {
    AppCollapseItem,
    ConfigInputWrapper
  },
  data() {
    return {
      levels,
      level: '',
      value: '',
      config: {},
      loading: false,
      init: false
    };
  },
  props: {
    param: {
      type: Object,
      required: true
    },
    configurations: {
      type: Object,
      required: true
    },
    selectedUserId: {
      type: String,
      required: false
    },
    application: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.config = this.configurations[this.param.parameter_id] || {};
    this.initParameter(this.config);
    this.param.visible = true;
    this.init = true;
  },
  computed: {
    ...mapGetters('Empresas', [
      'isSavingConfigurations'
    ]),
    configurationDate() {
      return this.config.fechaConfiguracion || 'Nunca';
    },
    levelsVisibles() {
      if (process.env.VUE_APP_AMBIENTE === 'desarrollo') {
        return this.levels;
      }
      return this.levels.filter((value) => value.id !== 'global' && value.id !== 'portal' && value.id !== 'app');
    },
    levelDescription() {
      return levels.find((level) => level.id === this.level)?.description;
    },
  },
  methods: {
    ...mapActions('Empresas', [
      'saveConfiguration'
    ]),
    capitalize,
    changeLevelView(level) {
      this.level = level;
      const config = this.findValueLevel(this.config, level);
      const [, valueSelected] = config;
      this.value = valueSelected;
    },
    initParameter(configuration) {
      const config = this.findValueLevel(configuration);
      const [levelSelected, valueSelected] = config;
      this.value = valueSelected;
      this.level = valueSelected ? levelSelected : '';
    },
    onSaveValue(newValue) {
      this.config[`valor${capitalize(this.level)}`] = newValue;
      this.value = newValue;
    },
    findValueLevel(configuration = {}, levelToFind = 'usuarioEmpresaApp') {
      console.log('findValueLevel:', configuration, levelToFind);
      const levelFound = levels.find((level) => level.id === levelToFind);
      return levels.filter((level) => level.level <= levelFound.level)
        .map((level) => level.id).map((level) => [level, configuration[`valor${capitalize(level)}`]]).reverse()
        .find(([, config]) => config) || ['global'];
    }
  }
};
</script>

<style scoped>
.icon-header {
  top: 7px;
}

.level-config {
  cursor: pointer;
}
</style>
